import { createSlice } from '@reduxjs/toolkit';
import { getManagerListByCompanyId } from './managersThunk';

const initialState = {
  managers: [],
};

const companyManagerSlice = createSlice({
  name: 'companyManagers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getManagerListByCompanyId.fulfilled, (state, { payload }) => {
        state.managers = payload.map((userData) => {
          const { createdAt, userId, role, user } = userData;
          const name = user?.name;
          const email = user?.email;

          return { createdAt, userId, role, name, email };
        });
      })
      .addCase(getManagerListByCompanyId.rejected, (_, { payload }) => {
        throw payload;
      });
  },
});

export default companyManagerSlice.reducer;
